import { z } from 'zod';
import validarCpf from '../../util/validarCpf';

const CPF_ISENTO = '111.111.111-11';

const texto = value =>
  value === undefined || value === null ? '' : String(value);

const digitos = value => texto(value).replace(/\D/g, '');

const dataNascimentoValida = value => {
  const raw = texto(value).trim();
  if (!digitos(raw)) return true;
  if (raw.includes('_')) return false;

  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(raw);
  if (!match) return false;

  const dia = Number(match[1]);
  const mes = Number(match[2]);
  const ano = Number(match[3]);
  const data = new Date(ano, mes - 1, dia);
  return (
    data.getFullYear() === ano &&
    data.getMonth() === mes - 1 &&
    data.getDate() === dia
  );
};

const cepValido = value => {
  const raw = texto(value);
  const numeros = digitos(raw);
  if (!numeros) return true;
  if (raw.includes('_')) return false;
  return numeros.length === 8;
};

const telefoneValido = value => {
  const raw = texto(value);
  if (!digitos(raw)) return true;
  return !raw.includes('_');
};

export const pacienteFormSchema = z.object({
  NOMEPAC: z
    .string()
    .trim()
    .min(1, 'Informe o nome do paciente.'),
  ENDMARPAC: z
    .string()
    .refine(
      value => value === CPF_ISENTO || validarCpf(value || ''),
      'CPF inválido!'
    ),
  DTNPAC: z
    .string()
    .refine(dataNascimentoValida, 'Data de nascimento inválida.'),
  CEPPAC: z.string().refine(cepValido, 'CEP inválido.'),
  FONERESPAC: z.string().refine(telefoneValido, 'Fone residencial incompleto.'),
  FONECOMPAC: z.string().refine(telefoneValido, 'Fone comercial incompleto.'),
  FONERECPAC: z
    .string()
    .refine(telefoneValido, 'Fone de agendamento incompleto.'),
  CELULARPAC: z.string().refine(telefoneValido, 'Fone de WhatsApp incompleto.'),
});

export const validarPacienteForm = paciente => {
  const result = pacienteFormSchema.safeParse({
    NOMEPAC: texto(paciente && paciente.NOMEPAC),
    ENDMARPAC: texto(paciente && paciente.ENDMARPAC),
    DTNPAC: texto(paciente && paciente.DTNPAC),
    CEPPAC: texto(paciente && paciente.CEPPAC),
    FONERESPAC: texto(paciente && paciente.FONERESPAC),
    FONECOMPAC: texto(paciente && paciente.FONECOMPAC),
    FONERECPAC: texto(paciente && paciente.FONERECPAC),
    CELULARPAC: texto(paciente && paciente.CELULARPAC),
  });

  if (result.success) return {};

  return result.error.issues.reduce((errors, issue) => {
    const campo = issue.path[0];
    if (!errors[campo]) errors[campo] = issue.message;
    return errors;
  }, {});
};
